import "@fontsource/montserrat";
import { BackToTop, Header } from "components";
import { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";
import { Navigator } from "./Navigator";


function App() {
  return (
    //@ts-ignore
    <BrowserRouter>
      <StrictMode>
        <Header />
        <Navigator />
        <BackToTop />
      </StrictMode>
    </BrowserRouter>
  );
}

export default App;
